export const formatIban = (iban: string): string => {
	if (!iban) return '';
	if (iban.indexOf(' ') >= 0) return iban;
	return iban.split('').map((char, index) => {
		if (index !== 0 && index % 4 === 0) return ' ' + char;
		return char;
	}).join('');
};